import React from 'react'
import styled from 'styled-components'
export const RegionLabel = ({
  x,
  y,
  data,
}: {
  x: number
  y: number
  data: RegionLabelType
}) => {
  const { r = 20, color = '#D3343F', label } = data

  return (
    <RegionLabelGroup transform={`translate(${x},${y})`}>
      <MarkerBackground rx={r[0]} ry={r[1]} opacity={0.5} />
      <MarkerForeground rx={r[0]} ry={r[1]} color={color} />
      {label && (
        <>
          <LabelBG textAnchor='middle' stroke={color} y={-r[1] - 4}>
            {label}
          </LabelBG>
          <Label textAnchor='middle' y={-r[1] - 4}>
            {label}
          </Label>
        </>
      )}
    </RegionLabelGroup>
  )
}
const Label = styled.text`
  font-weight: 700;
  fill: var(--site-background);
`
const LabelBG = styled.text`
  font-weight: 700;
  stroke-width: 4;
  @media only screen and (max-width: 711px) {
    stroke-width: 3;
  }
`
const MarkerForeground = styled.ellipse<{ color: string }>`
  fill: none;
  stroke: ${({ color }) => color};
  stroke-width: 2;
  @media only screen and (max-width: 711px) {
    stroke-width: 1.5;
  }
`
const MarkerBackground = styled.ellipse`
  fill: none;
  stroke: var(--site-background);
  stroke-width: 6;
  @media only screen and (max-width: 711px) {
    stroke-width: 4;
  }
`

const RegionLabelGroup = styled.g`
  font-size: 15px;
  font-weight: 400;
  font-family: var(--font-sans-serif);
  fill: #202346;
`
